import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const mediaSrc = (u) => (u && u.startsWith("/") ? `${BASE}${u}` : u);

export const useHero = (poll = false, tick = 0) => {
  const [hero, setHero] = useState(null);
  useEffect(() => {
    let alive = true, t;
    const load = () => api.get("/site/hero").then((r) => {
      if (!alive) return;
      setHero(r.data);
      if (poll && r.data.status === "generating") t = setTimeout(load, 5000);
    }).catch(() => {});
    load();
    return () => { alive = false; clearTimeout(t); };
  }, [poll, tick]);
  return hero;
};

export const HeroVideo = ({ fallbackImage }) => {
  const hero = useHero(false);
  const hasVideo = !!(hero && hero.video_url);
  const poster = mediaSrc(hero?.poster_url) || fallbackImage;
  return (
    <div className="absolute inset-0 bg-black" data-testid="hero-media">
      {poster && !hasVideo && <img src={poster} alt="" className="absolute inset-0 h-full w-full object-cover opacity-80" />}
      {hasVideo && (
        <video key={hero.video_url} data-testid="hero-video" className="hero-video absolute inset-0 h-full w-full object-cover"
          poster={poster} autoPlay muted loop playsInline preload="auto">
          {hero.webm_url && <source src={mediaSrc(hero.webm_url)} type="video/webm" />}
          <source src={mediaSrc(hero.video_url)} type="video/mp4" />
        </video>
      )}
    </div>
  );
};
